import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngxs/store';
import { ERR_SPECS_FOR_CHECKOUT_ERROR_TYPES } from '@platform-frontend/checkout';
import { ErrorSpecificationProvider, MSG_PLATFORM_DEFAULT } from '@platform-frontend/platform';
import { LocaleSetupService } from '@platform-frontend/transloco';
import { TranslocoErrorSpecification } from '@platform-frontend/ui-tools';
import { CloseWindow } from '@platform-frontend/util';
import { Observable } from 'rxjs';
import { AppRoutesService } from '../../app-routes.service';
import { WebCheckoutIntegrationService } from '../../integration/web-checkout-integration.service';

@Component({
  selector: 'yat-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private appRoutesService: AppRoutesService,
    private errorSpecificationProvider: ErrorSpecificationProvider,
    private localeSetupService: LocaleSetupService,
    private store: Store,
    private webCheckoutIntegrationService: WebCheckoutIntegrationService
  ) {}

  errorSpecification$: Observable<TranslocoErrorSpecification>;

  ngOnInit(): void {
    const locale = this.activatedRoute.snapshot.queryParamMap.get('locale');
    if (locale) {
      this.localeSetupService.setLocaleByApi(locale);
    }

    this.errorSpecification$ = this.errorSpecificationProvider.getErrorSpecification(
      [MSG_PLATFORM_DEFAULT.key],
      () => this.store.dispatch(new CloseWindow()),
      () => this.tryAgain().subscribe(),
      ERR_SPECS_FOR_CHECKOUT_ERROR_TYPES
    );
  }

  private tryAgain(): Observable<unknown> {
    const referrerUrl = this.activatedRoute.snapshot.queryParamMap.get('referrer');
    return this.webCheckoutIntegrationService.restart(referrerUrl ? this.appRoutesService.adjustToFlowStartupUrl(referrerUrl) : undefined);
  }
}
